import React, { useEffect, useState } from "react";
import { Formik, FieldArray, Field } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Breadcrums from "../../../common/breadcrumbs";
// import Loader from "../../../common/loader";
import CustomCkeditor from "../../../common/customeditor";
import * as pageServices from "../../../services/website.services";
import {
  globalLoader,
  handleServerValidations,
} from "../../../../../utils/commonfunction";
import { SWAL_SETTINGS, INPUT_LENGTH_50, MENU_LOCATION, showFilterList } from "../../../../../utils/Constants";
import { Tooltip, Whisper, Loader } from "rsuite";
import { useTranslation } from "react-i18next";

const PageEdit = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  const [dataLoaded, setDataLoaded] = useState(false);
  const [saveType, setSaveType] = useState("");
  const { t } = useTranslation()  

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: "Website", url: "/admin/cms/website/list/1" },
    { title: t("btn_edit"), url: "" },
  ];

  useEffect(() => {
    pageServices
      .Details(params.id)
      .then((data) => {
        setShowDefault(data && data?.data ? data.data : []);
        setTimeout(() => {
          setDataLoaded(true);
        }, 100);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {dataLoaded ? (<Formik
        enableReinitialize
        initialValues={{
          title: showdefault && showdefault.title ? showdefault.title : "",
          slug: showdefault && showdefault.slug ? showdefault.slug : "",
          status:
            showdefault && showdefault.status,
          sections: showdefault && showdefault.sections ? showdefault.sections.map(s => ({
            ...s,
            imagePreview: s.image || null,
            subsections: s.subsections ? s.subsections.map(sub => ({
              ...sub,
              imagePreview: sub.image || null
            })) : []
          })) : [{ title: "", shortDescription: undefined, longDescription: undefined, image: undefined, imagePreview: undefined, subsections: [] }],
        }}
        validate={(values) => {
          const error = {};

          const title = values.title?.trim() || "";
          const slug = values.slug?.trim() || "";

          if (!title) error.title = t("label_title_error");
          else if (title.length > INPUT_LENGTH_50)
            error.title = t("validation_err_reached_maximum_length");

          if (!slug) error.slug = t("label_slug_error");
          else if (slug.length > INPUT_LENGTH_50)
            error.slug = t("validation_err_reached_maximum_length");

          if (!values.status) error.status = t("validation_err_status_required");

          return error;
        }}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          globalLoader(true);
          const id = params.id;
          
          const submitAfterUploads = async () => {
            try {
              let formData = new FormData();
              formData.append("title", values.title);
              formData.append("slug", values.slug);
              formData.append("status", values.status);
              formData.append("listKey", "WEBSITE");

              let sectionsPayload = values.sections.map(sec => {
                return {
                  ...sec,
                  subsections: sec.subsections ? sec.subsections.map(sub => ({ ...sub })) : []
                };
              });
              for (let i = 0; i < sectionsPayload.length; i++) {
                 if (sectionsPayload[i].image && typeof sectionsPayload[i].image !== 'string') {
                    let imgForm = new FormData();
                    imgForm.append("file", sectionsPayload[i].image);
                    imgForm.append("folder", "cms");
                    try {
                      const res = await pageServices.UploadMedia(imgForm);
                      if (res?.data?.url) {
                        sectionsPayload[i].image = res.data.url;
                      } else {
                        sectionsPayload[i].image = null;
                      }
                    } catch (err) {
                      console.error("Image upload failed", err);
                      sectionsPayload[i].image = null;
                    }
                 }
                 delete sectionsPayload[i].imagePreview;

                 if (sectionsPayload[i].subsections && sectionsPayload[i].subsections.length > 0) {
                    for (let j = 0; j < sectionsPayload[i].subsections.length; j++) {
                       let sub = sectionsPayload[i].subsections[j];
                       if (sub.image && typeof sub.image !== 'string') {
                          let imgForm = new FormData();
                          imgForm.append("file", sub.image);
                          imgForm.append("folder", "cms");
                          try {
                            const res = await pageServices.UploadMedia(imgForm);
                            if (res?.data?.url) {
                              sub.image = res.data.url;
                            } else {
                              sub.image = null;
                            }
                          } catch (err) {
                            console.error("Subsection image upload failed", err);
                            sub.image = null;
                          }
                       }
                       delete sub.imagePreview;
                    }
                 }
              }
              
                let finalSections = sectionsPayload.map(sec => {
                  const cleaned = {};
                  for (const key in sec) {
                    if (key !== "imagePreview" && sec[key] !== undefined && sec[key] !== null && sec[key] !== "") {
                      if (key === "subsections") {
                        const cleanedSubs = sec.subsections.map(sub => {
                          const cleanedSub = {};
                          for (const subKey in sub) {
                            if (subKey !== "imagePreview" && sub[subKey] !== undefined && sub[subKey] !== null && sub[subKey] !== "") {
                              cleanedSub[subKey] = sub[subKey];
                            }
                          }
                          return cleanedSub;
                        }).filter(sub => Object.keys(sub).length > 0);
                        if (cleanedSubs.length > 0) {
                          cleaned.subsections = cleanedSubs;
                        }
                      } else {
                        cleaned[key] = sec[key];
                      }
                    }
                  }
                  return cleaned;
                }).filter(sec => Object.keys(sec).length > 0);
                
                formData.append("sections", JSON.stringify(finalSections));

              pageServices
                .Edit(formData, id)
                .then((response) => {
                  setSubmitting(false);
                  if (response.success) {
                    Swal.fire({
                      icon: "success",
                      text: response.message,
                      ...SWAL_SETTINGS,
                    });
                    if (saveType !== "Save") {
                      setTimeout(() => {
                        resetForm({ values: "" });
                        globalLoader(false);
                        navigate(`/admin/cms/website/list/1`);
                      }, 1000);
                    }
                    if (saveType === "Save") {
                      setTimeout(() => {
                        globalLoader(false);
                      }, 1000);
                    }
                  } else {
                    Swal.fire({
                      icon: "error",
                      text: handleServerValidations(response),
                      ...SWAL_SETTINGS,
                    });
                    globalLoader(false);
                  }
                })
                .catch((error) => {
                  console.log("error ====> ", error);
                  globalLoader(false);
                });
            } catch (e) {
              console.error(e);
              globalLoader(false);
            }
          };
          submitAfterUploads();
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          setFieldTouched,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <div className="row row-sm">
              <div className="col-lg-12 col-md-12 animation_fade">
                <div className="card custom-card">
                  <div className="card-body">
                    <div>
                      <h6 className="main-content-label mb-3">{t("edit_cms")}</h6>
                    </div>
                    {showdefault && Object.keys(showdefault).length > 0 ? (
                      <div className="row row-sm">

                        <div className="col-lg-6 text-center form-group">
                          <label htmlFor="title" className="text-left d-flex">
                            {t("label_page_titles")}:<span className="requirestar">*</span>
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>
                                  {t("tooltip_page_title")}
                                </Tooltip>
                              }
                            >
                              <span className="field-more-info mt-1 ms-1 cp">
                                ?
                              </span>
                            </Whisper>
                          </label>
                         
                          <input
                            name="title"
                            id="title"
                            type="text"
                            placeholder="Enter the title"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.title}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.title && touched.title && errors.title}
                          </span>
                        </div>

                        <div className="col-lg-6 text-center form-group">
                          <label htmlFor="slug" className="text-left d-flex">
                            {t("label_slug_of_page")}:<span className="requirestar">*</span>
                          </label>
                          <input
                            name="slug"
                            id="slug"
                            type="text"
                            placeholder="Enter the slug"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.slug}
                            disabled={"disabled"}
                            className="form-control"
                          />
                          <span className="text-danger d-flex text-left">
                            {errors.slug && touched.slug && errors.slug}
                          </span>
                        </div>

                        <div className="col-md-12 text-center form-group">
                          <label htmlFor="status" className="text-left d-flex">
                            {t("list_heading_status")}:
                            <span className="requirestar">*</span>{" "}
                          </label>
                          <div className=" select-down-arrow">
                            <select
                              name="status"
                              id="status"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.status}
                              className="form-control" >

                              {(showFilterList).map((value, i) => {
                                return (
                                  <option key={i} value={value.status__id}>{t(`${value.name}`)}</option>
                                )
                              })}
                            </select>
                          </div>
                          <span className="text-danger d-flex text-left">
                            {errors.status &&
                              touched.status &&
                              errors.status}
                          </span>
                        </div>

                        {/* <div className="col-lg-12 text-center form-group required">
                          <label
                            htmlFor="meta_tags"
                            className="text-left d-flex"
                          >
                             {t("meta_tags")}:{" "}
                          </label>
                          <textarea
                            name="meta_tags"
                            id="meta_tags"
                            rows="2"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.meta_tags}
                            className="form-control"
                          />
                        </div> */}
                        {/* <div className="col-lg-12 text-center form-group required">
                          <label
                            htmlFor="meta_keyword"
                            className="text-left d-flex"
                          >
                             {t("meta_keywords")}:{" "}
                          </label>
                          <textarea
                            name="meta_keyword"
                            id="meta_keyword"
                            rows="2"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.meta_keyword}
                            className="form-control"
                          />
                        </div> */}
                        <div className="col-lg-12">
                          <hr />
                          <h6 className="main-content-label mb-3">Sections</h6>
                          <FieldArray name="sections">
                            {({ insert, remove, push }) => (
                              <div>
                                {values.sections && values.sections.length > 0 &&
                                  values.sections.map((section, index) => (
                                    <div className="row mb-4 p-3 border rounded" key={index} style={{ borderColor: "#e0e0f0" }}>
                                      <div className="col-lg-12 d-flex justify-content-between align-items-center mb-3">
                                        <h6 className="m-0">Section {index + 1}</h6>
                                      </div>
                                      
                                      <div className="col-lg-6 form-group text-left">
                                        <label>Title</label>
                                        <Field
                                          name={`sections.${index}.title`}
                                          className="form-control"
                                          placeholder="Section Title"
                                        />
                                      </div>

                                      {section.image !== undefined && (
                                        <div className="col-lg-6 form-group text-left">
                                          <div className="d-flex justify-content-between align-items-center">
                                            <label>Image</label>
                                            {/* <button
                                              type="button"
                                              className="btn text-danger btn-link p-0 mb-1"
                                              style={{ fontSize: "12px", textDecoration: "none" }}
                                              onClick={() => {
                                                setFieldValue(`sections.${index}.image`, undefined);
                                                setFieldValue(`sections.${index}.imagePreview`, undefined);
                                              }}
                                            >
                                              <i className="fa fa-times-circle"></i> Remove Field
                                            </button> */}
                                          </div>
                                          <input
                                            name={`sections.${index}.image`}
                                            type="file"
                                            accept="image/*"
                                            className="form-control"
                                            onChange={(event) => {
                                              const file = event.currentTarget.files[0];
                                              setFieldValue(`sections.${index}.image`, file);
                                              if (file) {
                                                setFieldValue(`sections.${index}.imagePreview`, URL.createObjectURL(file));
                                              }
                                            }}
                                          />
                                          {typeof section.image === "string" && (
                                            <div className="mt-1 text-left" style={{ fontSize: "12px", wordBreak: "break-all" }}>
                                              <span className="text-muted">Current: </span>
                                              <a href={section.image} target="_blank" rel="noreferrer" style={{ textDecoration: "underline" }}>
                                                {section.image.split("?")[0].split("/").pop()}
                                              </a>
                                            </div>
                                          )}
                                          {section.imagePreview && (
                                            <div className="mt-2 text-left">
                                              <img
                                                src={section.imagePreview}
                                                alt="Preview"
                                                style={{ maxWidth: "100px", borderRadius: "8px" }}
                                              />
                                            </div>
                                          )}
                                        </div>
                                      )}

                                      {section.shortDescription !== undefined && (
                                        <div className="col-lg-12 form-group text-left">
                                          <div className="d-flex justify-content-between align-items-center">
                                            <label>Short Description</label>
                                            {/* <button
                                              type="button"
                                              className="btn text-danger btn-link p-0 mb-1"
                                              style={{ fontSize: "12px", textDecoration: "none" }}
                                              onClick={() => setFieldValue(`sections.${index}.shortDescription`, undefined)}
                                            >
                                              <i className="fa fa-times-circle"></i> Remove Field
                                            </button> */}
                                          </div>
                                          <Field
                                            as="textarea"
                                            name={`sections.${index}.shortDescription`}
                                            className="form-control"
                                            rows="2"
                                            placeholder="Short Description"
                                          />
                                        </div>
                                      )}

                                      {section.longDescription !== undefined && (
                                        <div className="col-lg-12 form-group text-left">
                                          <div className="d-flex justify-content-between align-items-center">
                                            <label>Long Description</label>
                                            {/* <button
                                              type="button"
                                              className="btn text-danger btn-link p-0 mb-1"
                                              style={{ fontSize: "12px", textDecoration: "none" }}
                                              onClick={() => setFieldValue(`sections.${index}.longDescription`, undefined)}
                                            >
                                              <i className="fa fa-times-circle"></i> Remove Field
                                            </button> */}
                                          </div>
                                          <Field
                                            as="textarea"
                                            name={`sections.${index}.longDescription`}
                                            className="form-control"
                                            rows="4"
                                            placeholder="Long Description (replaces rich text editor)"
                                          />
                                        </div>
                                      )}

                                      <div className="col-lg-12 mb-3">
                                        {(section.shortDescription === undefined || section.longDescription === undefined || section.image === undefined) && (
                                          <div className="d-flex align-items-center flex-wrap" style={{ gap: "8px" }}>
                                            {/* <span style={{ fontSize: "12px", color: "#666" }}>Add Field:</span> */}
                                            {/* {section.shortDescription === undefined && (
                                              <button
                                                type="button"
                                                className="btn btn-outline-info btn-sm"
                                                onClick={() => setFieldValue(`sections.${index}.shortDescription`, "")}
                                              >
                                                + Short Description
                                              </button>
                                            )} */}
                                            {/* {section.image === undefined && (
                                              <button
                                                type="button"
                                                className="btn btn-outline-info btn-sm"
                                                onClick={() => {
                                                  setFieldValue(`sections.${index}.image`, null);
                                                  setFieldValue(`sections.${index}.imagePreview`, null);
                                                }}
                                              >
                                                + Image
                                              </button>
                                            )} */}
                                            {/* {section.longDescription === undefined && (
                                              <button
                                                type="button"
                                                className="btn btn-outline-info btn-sm"
                                                onClick={() => setFieldValue(`sections.${index}.longDescription`, "")}
                                              >
                                                + Long Description
                                              </button>
                                            )} */}
                                          </div>
                                        )}
                                      </div>

                                       {/* Subsections Area */}
                                       <div className="col-lg-12 mt-3">
                                         <h6 className="main-content-label-sub mb-2" style={{ fontSize: "14px", fontWeight: "600" }}>Sub-sections</h6>
                                         <FieldArray name={`sections.${index}.subsections`}>
                                           {({ insert: insertSub, remove: removeSub, push: pushSub }) => (
                                             <div>
                                               {section.subsections && section.subsections.length > 0 &&
                                                 section.subsections.map((subSection, subIndex) => (
                                                   <div className="row mb-3 p-3 border rounded bg-light" key={subIndex} style={{ borderColor: "#d0d0e0" }}>
                                                     <div className="col-lg-12 d-flex justify-content-between align-items-center mb-2">
                                                       <span style={{ fontWeight: "600" }}>Sub-section {subIndex + 1}</span>
                                                       {/* <button
                                                         type="button"
                                                         className="btn btn-danger btn-sm"
                                                         onClick={() => removeSub(subIndex)}
                                                       >
                                                         <i className="fa fa-trash"></i> Remove Sub-section
                                                       </button> */}
                                                     </div>

                                                     {subSection.shortDescription !== undefined && (
                                                       <div className="col-lg-6 form-group text-left">
                                                         <div className="d-flex justify-content-between align-items-center">
                                                           <label>Short Description</label>
                                                           {/* <button
                                                             type="button"
                                                             className="btn text-danger btn-link p-0 mb-1"
                                                             style={{ fontSize: "12px", textDecoration: "none" }}
                                                             onClick={() => setFieldValue(`sections.${index}.subsections.${subIndex}.shortDescription`, undefined)}
                                                           >
                                                             <i className="fa fa-times-circle"></i> Remove Field
                                                           </button> */}
                                                         </div>
                                                         <Field
                                                           as="textarea"
                                                           name={`sections.${index}.subsections.${subIndex}.shortDescription`}
                                                           className="form-control"
                                                           rows="2"
                                                           placeholder="Sub-section Short Description"
                                                         />
                                                       </div>
                                                     )}

                                                     {subSection.image !== undefined && (
                                                       <div className="col-lg-6 form-group text-left">
                                                         <div className="d-flex justify-content-between align-items-center">
                                                           <label>Image</label>
                                                           {/* <button
                                                             type="button"
                                                             className="btn text-danger btn-link p-0 mb-1"
                                                             style={{ fontSize: "12px", textDecoration: "none" }}
                                                             onClick={() => {
                                                               setFieldValue(`sections.${index}.subsections.${subIndex}.image`, undefined);
                                                               setFieldValue(`sections.${index}.subsections.${subIndex}.imagePreview`, undefined);
                                                             }}
                                                           >
                                                             <i className="fa fa-times-circle"></i> Remove Field
                                                           </button> */}
                                                         </div>
                                                         <input
                                                           name={`sections.${index}.subsections.${subIndex}.image`}
                                                           type="file"
                                                           accept="image/*"
                                                           className="form-control"
                                                           onChange={(event) => {
                                                             const file = event.currentTarget.files[0];
                                                             setFieldValue(`sections.${index}.subsections.${subIndex}.image`, file);
                                                             if (file) {
                                                               setFieldValue(`sections.${index}.subsections.${subIndex}.imagePreview`, URL.createObjectURL(file));
                                                             }
                                                           }}
                                                         />
                                                         {typeof subSection.image === "string" && (
                                                           <div className="mt-1 text-left" style={{ fontSize: "12px", wordBreak: "break-all" }}>
                                                             <span className="text-muted">Current: </span>
                                                             <a href={subSection.image} target="_blank" rel="noreferrer" style={{ textDecoration: "underline" }}>
                                                               {subSection.image.split("?")[0].split("/").pop()}
                                                             </a>
                                                           </div>
                                                         )}
                                                         {subSection.imagePreview && (
                                                           <div className="mt-2 text-left">
                                                             <img
                                                               src={subSection.imagePreview}
                                                               alt="Preview"
                                                               style={{ maxWidth: "100px", borderRadius: "8px" }}
                                                             />
                                                           </div>
                                                         )}
                                                       </div>
                                                     )}

                                                     {subSection.longDescription !== undefined && (
                                                       <div className="col-lg-12 form-group text-left">
                                                         <div className="d-flex justify-content-between align-items-center">
                                                           <label>Long Description</label>
                                                           {/* <button
                                                             type="button"
                                                             className="btn text-danger btn-link p-0 mb-1"
                                                             style={{ fontSize: "12px", textDecoration: "none" }}
                                                             onClick={() => setFieldValue(`sections.${index}.subsections.${subIndex}.longDescription`, undefined)}
                                                           >
                                                             <i className="fa fa-times-circle"></i> Remove Field
                                                           </button> */}
                                                         </div>
                                                         <Field
                                                           as="textarea"
                                                           name={`sections.${index}.subsections.${subIndex}.longDescription`}
                                                           className="form-control"
                                                           rows="3"
                                                           placeholder="Sub-section Long Description"
                                                         />
                                                       </div>
                                                     )}

                                                     <div className="col-lg-12 mt-2">
                                                       {(subSection.shortDescription === undefined || subSection.longDescription === undefined || subSection.image === undefined) && (
                                                         <div className="d-flex align-items-center flex-wrap" style={{ gap: "8px" }}>
                                                           {/* <span style={{ fontSize: "12px", color: "#666" }}>Add Field:</span>
                                                           {subSection.shortDescription === undefined && (
                                                             <button
                                                               type="button"
                                                               className="btn btn-outline-info btn-xs"
                                                               onClick={() => setFieldValue(`sections.${index}.subsections.${subIndex}.shortDescription`, "")}
                                                             >
                                                               + Short Description
                                                             </button>
                                                           )}
                                                           {subSection.image === undefined && (
                                                             <button
                                                               type="button"
                                                               className="btn btn-outline-info btn-xs"
                                                               onClick={() => {
                                                                 setFieldValue(`sections.${index}.subsections.${subIndex}.image`, null);
                                                                 setFieldValue(`sections.${index}.subsections.${subIndex}.imagePreview`, null);
                                                               }}
                                                             >
                                                               + Image
                                                             </button>
                                                           )}
                                                           {subSection.longDescription === undefined && (
                                                             <button
                                                               type="button"
                                                               className="btn btn-outline-info btn-xs"
                                                               onClick={() => setFieldValue(`sections.${index}.subsections.${subIndex}.longDescription`, "")}
                                                             >
                                                               + Long Description
                                                             </button>
                                                           )} */}
                                                         </div>
                                                       )}
                                                     </div>
                                                   </div>
                                                 ))}
                                               {/* <button
                                                 type="button"
                                                 className="btn btn-outline-primary btn-sm mb-3"
                                                 onClick={() => pushSub({ shortDescription: undefined, longDescription: undefined, image: undefined, imagePreview: undefined })}
                                               >
                                                 <i className="fa fa-plus"></i> Add Sub-section
                                               </button> */}
                                             </div>
                                           )}
                                         </FieldArray>
                                       </div>
                                    </div>
                                  ))}
                                {/* <button
                                  type="button"
                                  className="btn btn-secondary mt-2 mb-4"
                                  onClick={() => push({ title: "", shortDescription: undefined, longDescription: undefined, image: undefined, imagePreview: undefined, subsections: [] })}
                                >
                                  <i className="fa fa-plus"></i> Add Section
                                </button> */}
                              </div>
                            )}
                          </FieldArray>
                        </div>


                        <div className="">
                          <button
                            onClick={() => {
                              setSaveType("Save");
                            }}
                            className="btn btn-info mr-2"
                            type="submit"
                          >
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_save")}
                          </button>
                          <button
                            onClick={() => {
                              setSaveType("");
                            }}
                            className="btn btn-success mr-2"
                            type="submit"
                          >
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_save_exit")}
                          </button>
                          <button
                            className="btn ripple btn-secondary"
                            type="button"
                            onClick={() => navigate(-1)}
                          >
                            <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                            {t("btn_cancel")}
                          </button>
                        </div>
                      </div>
                    ) : (
                      <Loader />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
        )}
      </Formik>
      ) : (
        <Loader />
      )}

    </>
  );
};

export default PageEdit;
